import Cookies from "js-cookie";

export default {
  namespaced: true,
  state: {
    user: null,
    jwt: null,
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload.user;
      Cookies.set("user", payload.user);

      state.jwt = payload.jwt;
      Cookies.set("jwt", payload.jwt);
    },
    logout(state) {
      state.user = null;
      Cookies.set("user", null);

      state.jwt = null;
      Cookies.set("jwt", null);
    },
  },
  actions: {
    initialize({ commit }) {
      let user = Cookies.get("user");
      let jwt = Cookies.get("jwt");
      if (user && user != "null") {
        commit("setUser", { user: JSON.parse(user), jwt });
      }
    },
  },
  getters: {
    username: (state) => {
      return state.user && state.user.username;
    },
  },
};
